import React, { useState, Component } from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import { ClockIcon, EditIcon, SparklesIcon, PhoneIcon, MailIcon, MessageCircleIcon, PlayIcon, Volume2Icon, BuildingIcon, CarIcon, RefreshCwIcon, XIcon, PhoneCallIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { WhatsAppChatModal } from '../components/whatsapp/WhatsAppChatModal';
import { LeadDetailOverlay } from '../components/leads/LeadDetailOverlay';
import { WhatsAppLead } from '../types/whatsapp';
type LeadType = 'sales' | 'service' | 'non-sales' | 'feedback';
type LeadStatus = 'cold' | 'warm' | 'hot' | 'completed' | 'partial' | 'loading';
type CallStatus = 'pending' | 'completed' | 'callback-requested' | 'not-available';
interface Lead {
  id: number;
  name: string;
  initials: string;
  type: string;
  email: string;
  phone: string;
  dealer: string;
  dealerCode: string;
  carModel: string;
  status: LeadStatus;
  callStatus: CallStatus;
  hasAI: boolean;
  aiResponse?: string;
  hasRecording: boolean;
  recordingDuration?: string;
  tags?: string[];
  multiVisit?: boolean;
}
const SALES_LEADS: Lead[] = [{
  id: 1,
  name: 'Zainaka',
  initials: 'ZA',
  type: 'Customer Meeting',
  email: 'Zainaka@gmail.com',
  phone: '+91 7019722046',
  dealer: 'Koncept Auto',
  dealerCode: 'HR407',
  carModel: 'Thar Roxx',
  status: 'cold',
  callStatus: 'pending',
  hasAI: true,
  aiResponse: 'Answered By AI',
  hasRecording: true,
  recordingDuration: '0:32',
  tags: ['Completed'],
  multiVisit: true
}, {
  id: 2,
  name: 'Sunil Yadav',
  initials: 'SY',
  type: 'Invoice',
  email: 'N/A',
  phone: '+91 7011523526',
  dealer: 'Koncept Auto',
  dealerCode: 'HR407',
  carModel: 'Bolero Neo',
  status: 'warm',
  callStatus: 'pending',
  hasAI: true,
  aiResponse: 'Analysed By AI',
  hasRecording: false,
  tags: ['Partial']
}, {
  id: 3,
  name: 'Data Loading...',
  initials: 'XX',
  type: 'N/A',
  email: 'N/A',
  phone: '+91 9773696968',
  dealer: 'Koncept Auto',
  dealerCode: 'HR407',
  carModel: 'Scorpio-N',
  status: 'cold',
  callStatus: 'callback-requested',
  hasAI: true,
  hasRecording: true,
  recordingDuration: '0:32'
}, {
  id: 4,
  name: 'Priya Sharma',
  initials: 'PS',
  type: 'Test Drive',
  email: 'priya.sharma@gmail.com',
  phone: '+91 9876543210',
  dealer: 'Mumbai Motors',
  dealerCode: 'MH401',
  carModel: 'XUV700',
  status: 'hot',
  callStatus: 'completed',
  hasAI: false,
  hasRecording: true,
  recordingDuration: '1:45',
  tags: ['Completed']
}, {
  id: 5,
  name: 'Rahul Mehta',
  initials: 'RM',
  type: 'Finance Query',
  email: 'rahul.m@yahoo.com',
  phone: '+91 9123456789',
  dealer: 'Delhi Auto Hub',
  dealerCode: 'DL302',
  carModel: 'Thar',
  status: 'warm',
  callStatus: 'pending',
  hasAI: true,
  aiResponse: 'Answered By AI',
  hasRecording: false
}];
// Outbound Call Popup Component
function OutboundCallPopup({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  if (!isOpen) return null;
  return <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center" onClick={onClose} data-id="element-1861">
        {/* Popup */}
        <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-sm w-full mx-4 transform transition-all" onClick={e => e.stopPropagation()} data-id="element-1862">
          <div className="flex items-center justify-between mb-4" data-id="element-1863">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-1864">
              <PhoneCallIcon size={24} className="text-green-600" data-id="element-1865" />
            </div>
            <button onClick={onClose} className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors" data-id="element-1866">
              <XIcon size={18} data-id="element-1867" />
            </button>
          </div>

          <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1868">
            Outbound Call Initiated
          </h3>
          <p className="text-sm text-gray-600 mb-5" data-id="element-1869">
            Outbound call initiated to this customer.
          </p>

          <button onClick={onClose} className="w-full py-2.5 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors" data-id="element-1870">
            OK
          </button>
        </div>
      </div>
    </>;
}
export function LeadsManagement() {
  const navigate = useNavigate();
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [selectedChatLead, setSelectedChatLead] = useState<WhatsAppLead | null>(null);
  const [isDetailOverlayOpen, setIsDetailOverlayOpen] = useState(false);
  const [selectedDetailLead, setSelectedDetailLead] = useState<any>(null);
  const [isCallPopupOpen, setIsCallPopupOpen] = useState(false);
  const handleOpenChat = (lead: Lead) => {
    const whatsappLead: WhatsAppLead = {
      id: lead.id,
      name: lead.name,
      phone: lead.phone,
      source: 'whatsapp',
      unreadCount: 0,
      aiScore: 75,
      status: 'active',
      tags: lead.tags || [],
      carModel: lead.carModel,
      dealer: lead.dealer
    };
    setSelectedChatLead(whatsappLead);
    setIsChatOpen(true);
  };
  const handleOpenDetailOverlay = (lead: Lead) => {
    setSelectedDetailLead({
      id: lead.id,
      name: lead.name,
      initials: lead.initials,
      email: lead.email,
      phone: lead.phone,
      callDuration: lead.recordingDuration || '12:21 Sec',
      leadType: lead.status,
      status: lead.type,
      carModel: lead.carModel
    });
    setIsDetailOverlayOpen(true);
  };
  const handleInitiateCall = (lead: Lead) => {
    setIsCallPopupOpen(true);
  };
  return <div className="flex w-full min-h-screen bg-[#f5f7fa]" data-id="element-1871">
      <Sidebar data-id="element-1872" />
      <main className="flex-1 flex flex-col h-screen overflow-hidden" data-id="element-1873">
        <Header data-id="element-1874" />
        <div className="flex-1 overflow-y-auto p-6" data-id="element-1875">
          <h1 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-1876">Sales Leads</h1>

          {/* Table Container */}
          <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-1877">
            {/* Table Header */}
            <div className="grid grid-cols-[48px_1fr_1fr_1fr_1fr] border-b border-gray-200" data-id="element-1878">
              <div className="p-4 flex items-center justify-center" data-id="element-1879">
                <input type="checkbox" className="w-4 h-4 rounded border-gray-300" data-id="element-1880" />
              </div>
              <div className="p-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1881">
                Lead Details
              </div>
              <div className="p-4 text-xs font-semibold text-gray-500 uppercase tracking-wider border-l border-gray-200" data-id="element-1882">
                Contact Information
              </div>
              <div className="p-4 text-xs font-semibold text-gray-500 uppercase tracking-wider border-l border-gray-200" data-id="element-1883">
                Dealer & Car Model
              </div>
              <div className="p-4 text-xs font-semibold text-gray-500 uppercase tracking-wider border-l border-gray-200" data-id="element-1884">
                Actions
              </div>
            </div>

            {/* Table Body */}
            {SALES_LEADS.map(lead => <div key={lead.id} className="grid grid-cols-[48px_1fr_1fr_1fr_1fr] border-b border-gray-100 last:border-b-0" data-id="element-1885">
                {/* Checkbox Column */}
                <div className="p-4 flex items-start justify-center pt-8 border-r border-gray-100" data-id="element-1886">
                  <input type="checkbox" className="w-4 h-4 rounded border-gray-300" data-id="element-1887" />
                </div>

                {/* Lead Details Column */}
                <div className="p-4 border-r border-gray-100" data-id="element-1888">
                  {lead.hasAI && <div className="flex items-center gap-1 text-blue-600 text-xs font-medium mb-3" data-id="element-1889">
                      <SparklesIcon size={14} data-id="element-1890" />
                      <span data-id="element-1891">AI</span>
                    </div>}

                  <div className="flex items-center gap-3 mb-3" data-id="element-1892">
                    <div className="w-11 h-11 rounded-lg bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-base" data-id="element-1893">
                      {lead.initials}
                    </div>
                    <div data-id="element-1894">
                      <p className="font-semibold text-gray-900 text-sm" data-id="element-1895">
                        {lead.name}
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-1896">{lead.type}</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 flex-wrap" data-id="element-1897">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium border ${lead.status === 'cold' ? 'bg-blue-50 text-blue-600 border-blue-200' : lead.status === 'warm' ? 'bg-orange-50 text-orange-500 border-orange-200' : lead.status === 'hot' ? 'bg-red-50 text-red-500 border-red-200' : 'bg-gray-50 text-gray-600 border-gray-200'}`} data-id="element-1898">
                      {lead.status.charAt(0).toUpperCase() + lead.status.slice(1)}
                    </span>
                    {lead.tags?.map((tag, idx) => <span key={idx} className={`px-3 py-1 rounded-full text-xs font-medium border ${tag === 'Completed' ? 'bg-green-50 text-green-600 border-green-200' : tag === 'Partial' ? 'bg-orange-50 text-orange-500 border-orange-200' : 'bg-gray-50 text-gray-600 border-gray-200'}`} data-id="element-1899">
                        {tag}
                      </span>)}
                  </div>
                </div>

                {/* Contact Information Column */}
                <div className="p-4 border-r border-gray-100" data-id="element-1900">
                  <div className="space-y-2" data-id="element-1901">
                    <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-1902">
                      <MailIcon size={16} className="text-gray-400" data-id="element-1903" />
                      <span data-id="element-1904">{lead.email}</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-1905">
                      <PhoneIcon size={16} className="text-gray-400" data-id="element-1906" />
                      <span data-id="element-1907">{lead.phone}</span>
                    </div>

                    {lead.callStatus === 'pending' && <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-orange-50 text-orange-600 border border-orange-200 mt-1" data-id="element-1908">
                        <span className="w-1.5 h-1.5 bg-orange-500 rounded-full" data-id="element-1909"></span>
                        Pending
                      </span>}
                    {lead.callStatus === 'callback-requested' && <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700 border border-gray-200 mt-1" data-id="element-1910">
                        <span className="w-1.5 h-1.5 bg-blue-500 rounded-full" data-id="element-1911"></span>
                        Call Back Requested
                      </span>}
                  </div>
                </div>

                {/* Dealer & Car Model Column */}
                <div className="p-4 border-r border-gray-100" data-id="element-1912">
                  <div className="flex items-center gap-2 text-sm text-gray-600 mb-2" data-id="element-1913">
                    <BuildingIcon size={16} className="text-gray-400" data-id="element-1914" />
                    <span data-id="element-1915">
                      {lead.dealer} -{' '}
                      <span className="font-semibold text-gray-900" data-id="element-1916">
                        {lead.dealerCode}
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-600 mb-3" data-id="element-1917">
                    <CarIcon size={16} className="text-gray-400" data-id="element-1918" />
                    <span data-id="element-1919">{lead.carModel}</span>
                  </div>

                  {lead.hasRecording && lead.recordingDuration ? <div className="inline-flex items-center gap-2 bg-blue-50 rounded-full px-3 py-1.5 border border-blue-100" data-id="element-1920">
                      <button className="text-gray-700 hover:text-blue-600" data-id="element-1921">
                        <PlayIcon size={12} fill="currentColor" data-id="element-1922" />
                      </button>
                      <span className="text-xs text-gray-600" data-id="element-1923">
                        0:00 / {lead.recordingDuration}
                      </span>
                      <div className="w-12 h-1 bg-blue-200 rounded-full relative" data-id="element-1924">
                        <div className="absolute left-0 top-0 h-1 w-0 bg-blue-500 rounded-full" data-id="element-1925"></div>
                      </div>
                      <button className="text-gray-700 hover:text-blue-600" data-id="element-1926">
                        <Volume2Icon size={12} data-id="element-1927" />
                      </button>
                    </div> : <div className="inline-flex px-3 py-1.5 bg-gray-100 rounded-full border border-gray-200" data-id="element-1928">
                      <span className="text-xs text-gray-500" data-id="element-1929">
                        Recording Not Available
                      </span>
                    </div>}
                </div>

                {/* Actions Column */}
                <div className="p-4" data-id="element-1930">
                  {lead.multiVisit && <div className="flex justify-end mb-3" data-id="element-1931">
                      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-semibold bg-green-50 text-green-600 border border-green-200 uppercase" data-id="element-1932">
                        <RefreshCwIcon size={10} data-id="element-1933" />
                        Multi-Visits
                      </span>
                    </div>}

                  <div className="flex items-center justify-end gap-2" data-id="element-1934">
                    <button className="w-9 h-9 rounded-full border-2 border-blue-200 flex items-center justify-center text-blue-500 hover:bg-blue-50 hover:border-blue-300 transition-colors" title="Schedule" data-id="element-1935">
                      <ClockIcon size={16} data-id="element-1936" />
                    </button>
                    <button onClick={() => handleInitiateCall(lead)} className="w-9 h-9 rounded-full border-2 border-blue-200 flex items-center justify-center text-blue-500 hover:bg-blue-50 hover:border-blue-300 transition-colors" title="Call" data-id="element-1937">
                      <PhoneIcon size={16} data-id="element-1938" />
                    </button>
                    <button onClick={() => handleOpenChat(lead)} className="w-9 h-9 rounded-full border-2 border-blue-200 flex items-center justify-center text-blue-500 hover:bg-blue-50 hover:border-blue-300 transition-colors" title="WhatsApp" data-id="element-1939">
                      <MessageCircleIcon size={16} data-id="element-1940" />
                    </button>
                    <button onClick={() => handleOpenDetailOverlay(lead)} className="w-9 h-9 rounded-full border-2 border-blue-200 flex items-center justify-center text-blue-500 hover:bg-blue-50 hover:border-blue-300 transition-colors" title="Edit" data-id="element-1941">
                      <EditIcon size={16} data-id="element-1942" />
                    </button>
                  </div>

                  {lead.aiResponse && <p className="text-xs text-gray-500 mt-3 text-right" data-id="element-1943">
                      {lead.aiResponse}
                    </p>}
                </div>
              </div>)}
          </div>
        </div>

        <WhatsAppChatModal isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} lead={selectedChatLead} data-id="element-1944" />
        <LeadDetailOverlay isOpen={isDetailOverlayOpen} onClose={() => setIsDetailOverlayOpen(false)} lead={selectedDetailLead} data-id="element-1945" />
        <OutboundCallPopup isOpen={isCallPopupOpen} onClose={() => setIsCallPopupOpen(false)} data-id="element-1946" />
      </main>
    </div>;
}